var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "mb-3" },
    [
      _c(
        "b-card-body",
        [
          _vm.isAdmin
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-suggestion", {
                        key: _vm.selectLegalEntityKey,
                        ref: "selectLegalEntity",
                        attrs: {
                          label: "Pessoa Jurídica",
                          column: "company_name,trading_name,cnpj",
                          model: "LegalEntity",
                          selectedModel: _vm.selectedLegalEntity,
                          appendClearOption: true,
                          placeholderText:
                            "Digite o nome ou cnpj da pessoa jurídica",
                          itemTextFormat: _vm.legalEntityItemTextFormat
                        },
                        on: {
                          "selected-model": function($event) {
                            return _vm.$emit(
                              "update:selectedLegalEntity",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._t("additional-filters"),
          _c(
            "b-row",
            { class: _vm.hasAdditionalFilters ? "mt-2" : "mt-2" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: _vm.hasAdditionalFilters ? 3 : 4 } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          _vm.reportTypePrefix + ".filters.start_date"
                        )
                      }
                    },
                    [
                      _c("datepicker", {
                        attrs: {
                          value: _vm.startDate,
                          format: "dd/MM/yyyy",
                          placeholder: _vm.$t(
                            _vm.reportTypePrefix +
                              ".filters.start_date_placeholder"
                          ),
                          "input-class": "form-control"
                        },
                        on: {
                          input: function($event) {
                            return _vm.$emit("update:startDate", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12", md: _vm.hasAdditionalFilters ? 3 : 4 } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          _vm.reportTypePrefix + ".filters.end_date"
                        )
                      }
                    },
                    [
                      _c("datepicker", {
                        attrs: {
                          value: _vm.endDate,
                          format: "dd/MM/yyyy",
                          placeholder: _vm.$t(
                            _vm.reportTypePrefix +
                              ".filters.end_date_placeholder"
                          ),
                          "input-class": "form-control"
                        },
                        on: {
                          input: function($event) {
                            return _vm.$emit("update:endDate", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end mt-3" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    size: "sm",
                    disabled: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("search")
                    }
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("action.search")) + " "),
                  _vm.loading
                    ? _c("feather-icon", {
                        staticClass: "animate-spin",
                        attrs: { icon: "LoaderIcon", size: "14" }
                      })
                    : _c("feather-icon", {
                        attrs: { icon: "SearchIcon", size: "14" }
                      })
                ],
                1
              ),
              _c(
                "b-button",
                {
                  staticClass: "mr-1",
                  attrs: {
                    variant: "secondary",
                    size: "sm",
                    disabled: _vm.loading
                  },
                  on: { click: _vm.handleClear }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("action.clear")) + " "),
                  _c("feather-icon", {
                    attrs: { icon: "RefreshCwIcon", size: "14" }
                  })
                ],
                1
              ),
              _vm.showExportButton && _vm.hasData
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "success",
                        size: "sm",
                        disabled: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("export")
                        }
                      }
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "FileTextIcon", size: "14" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t(_vm.reportTypePrefix + ".export_pdf")) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }